import React, { FunctionComponent, MouseEvent, useState } from 'react';

import axios from 'axios';
import { keyBy } from 'lodash';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ValueType } from 'react-select';

import { useProfile } from 'auth/Auth';
import { Select } from 'core/select/Select';
import { LocaleOption, LocaleOptions } from 'core/util/Locale';

import 'common/chrome/top-nav/locale-switcher/LocaleSwitcher.scss';

interface Props {
    show: boolean;
    onClose: (e: MouseEvent) => void;
}

export const LocaleSwitcher: FunctionComponent<Props> = (props) => {
    const { onClose, show } = props;
    const { t } = useTranslation(['common/chrome']);
    const [{ profile }] = useProfile();
    const localeOptionsByValue = keyBy(LocaleOptions, 'value');

    const [selectedLocale, setSelectedLocale] = useState<ValueType<LocaleOption>>(
        localeOptionsByValue[profile!.user.locale],
    );

    const onLocaleChange = (selectedOption: ValueType<LocaleOption>): void => {
        setSelectedLocale(selectedOption);
    };

    const onLocaleSwitch = (e: MouseEvent): void => {
        (async (): Promise<any> => {
            try {
                await axios.put(`/api/tenants/${profile!.user.tenantID}/my-account/${profile!.user.id}/set-locale`, {
                    args: {
                        locale: (selectedLocale as LocaleOption).value,
                    },
                });

                window.location.reload();
            } catch {
                // eslint-disable-line no-empty
            }
        })();

        onClose(e);
    };

    return (
        <Modal show={show} onHide={onClose} className="r4e-locale-switcher">
            <Modal.Header closeButton>
                <Modal.Title>{t('SWITCH_LOCALE')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Select
                    options={LocaleOptions.sort((a: LocaleOption, b: LocaleOption) => {
                        return a.label.localeCompare(b.label);
                    })}
                    value={selectedLocale}
                    onChange={onLocaleChange}
                    className="locales"
                />

                <div className="note text-muted">{t('SWITCH_LOCALE_NOTE')}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {t('CANCEL')}
                </Button>
                <Button variant="primary" onClick={onLocaleSwitch}>
                    {t('SWITCH')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
